/*rutas de Statement*/
import Statement from '@/apps/billing/views/Statement';
export default [
	{
		path: 'statement/:idinv/:idcus',
		name: 'Statement',
		folder: Statement,
	}
];
